import React, { useState } from "react";
import {
  Box,
  Button,
  Flex,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import * as FiIcons from "react-icons/fi";
import Pagination from "components/ui/pagination/Pagination";
import GButton from "components/ui/button/Button";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import EditTimeShift from "./modal/EditTimeShift";

export default function TimeLeveldetailsTable() {
  const { t } = useTranslation();
  const { TimeLeavelDetails, YearLookUpDropDown } = useSelector(
    (state) => state.attendanceSetting
  );
  const [ShowEditModal, setShowEditModal] = useState(false);
  /* --------------------------------------------- Start Pagination  -----------------------------------------------*/
  const recordsPerPage = 10;
  const [currentPageActive, setCurrentPageActive] = useState(1);
  const prePage = (currentPage, setCurrentPage) => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const nextPage = (currentPage, setCurrentPage, npage) => {
    if (currentPage < npage) {
      setCurrentPage(currentPage + 1);
    }
  };

  const calculateRecords = (TimeLeavelDetails, currentPage, recordsPerPage) => {
    const firstIndex = (currentPage - 1) * recordsPerPage;
    const lastIndex = Math.min(
      currentPage * recordsPerPage,
      TimeLeavelDetails?.length
    );
    return TimeLeavelDetails?.slice(firstIndex, lastIndex);
  };

  // Calculate records for activeDiscounts
  const TimeLeavelDetailsData = calculateRecords(
    TimeLeavelDetails,
    currentPageActive,
    recordsPerPage
  );
  /* --------------------------------------------- End Pagination  -----------------------------------------------*/

  return (
    <>
      <Box
        bg="light"
        overflow="auto"
        borderRadius={4}
        boxShadow="0rem 0.3125rem 0.3125rem 0rem rgba(82, 63, 105, 0.05)"
      >
        <Flex
          flexWrap="wrap"
          justifyContent="space-between"
          paddingBlock={2}
          p={4}
          borderBottom="1px solid"
          borderColor="border"
          bg="light"
          gap={2}
        >
          <Flex
            alignItems="center"
            flexWrap="wrap"
            textTransform="capitalize"
            gap={4}
            color="text"
            bg="light"
          >
            {/* <GButton
              title={t("general.all")}
              bg="none"
              isDisabled={false}
              borderRadius={0}
              borderColor="primary"
            /> */}
          </Flex>

          <GButton
            title={t("general.filter")}
            border="1px solid"
            borderColor="border"
            postfixElement={<FiIcons.FiFilter size={16} />}
            hover={{ bg: "primary", borderColor: "primary", color: "light" }}
            //onClick={() => setShowFilterCategoriesModal(true)}
          />
        </Flex>

        <Table>
          <Thead>
            <Tr>
              <Th>{t("pages.hr.attendance.year")}</Th>
              <Th>{t("pages.hr.attendance.from_date")}</Th>
              <Th>{t("pages.hr.attendance.to_date")}</Th>
              <Th>{t("pages.hr.attendance.from_time")}</Th>
              <Th>{t("pages.hr.attendance.to_time")}</Th>
              <Th>{t("pages.hr.attendance.edit")}</Th>
            </Tr>
          </Thead>
          <Tbody>
            {TimeLeavelDetailsData?.map((item, index) => (
              <Tr key={index} cursor={"pointer"}>
                <Td> {item?.Year_ID} </Td>
                <Td> {item?.From_Date} </Td>
                <Td> {item?.To_Date} </Td>
                <Td> {item?.FromTime} </Td>
                <Td> {item?.ToTime} </Td>

                <Td>
                  <Button
                    type="button"
                    bg="primary"
                    color="light"
                    textTransform="capitalize"
                    fontSize="1rem"
                    onClick={() => setShowEditModal(item)}
                  >
                    <Flex
                      justifyContent={"space-between"}
                      alignItems={"center"}
                    >
                      <span> {t("pages.hr.edit")} </span>
                    </Flex>
                  </Button>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
        <Pagination
          currentPage={currentPageActive}
          setCurrentPage={setCurrentPageActive}
          npage={Math.ceil(TimeLeavelDetails?.length / recordsPerPage)}
          prePage={() => prePage(currentPageActive, setCurrentPageActive)}
          nextPage={() =>
            nextPage(
              currentPageActive,
              setCurrentPageActive,
              Math.ceil(TimeLeavelDetails?.length / recordsPerPage)
            )
          }
        />
      </Box>
      {ShowEditModal && (
        <EditTimeShift
          onClose={() => setShowEditModal(false)}
          item={ShowEditModal}
          years={YearLookUpDropDown}
        />
      )}
    </>
  );
}
